import { __rest } from "tslib";
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
// Traced from the Figma "/Play" icon used for "Publish rule" (node 505:19927).
export function PublishRuleIcon(_a) {
    var { width = 24, height = 24 } = _a, props = __rest(_a, ["width", "height"]);
    return (<SvgIcon width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* explicit fill="none" — MUI's SvgIcon CSS class sets fill: currentColor on the root, which would otherwise fill this rect */}
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="2.25" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M9.45202 7.58082C9.72957 7.45584 10.0637 7.47706 10.3177 7.63582L16.151 11.2817C16.37 11.4185 16.5 11.6395 16.5 11.875C16.5 12.1105 16.37 12.3315 16.151 12.4683L10.3177 16.1142C10.0637 16.2729 9.72957 16.2942 9.45202 16.1692C9.17446 16.0442 9 15.794 9 15.5208V8.22917C9 7.95603 9.17446 7.7058 9.45202 7.58082Z" fill="currentColor"/>
    </SvgIcon>);
}
export default PublishRuleIcon;
